/* tslint:disable */
/* eslint-disable */
export enum VisualizationType {
    Exterior = 'Exterior',
    Interior = 'Interior',
    BirdsEye = 'Birds eye'
}
